import {Price} from '../price/price';
import {Item} from '../item/item';
import {UuidGenerator} from '../uuid-generator';

export class Transaction {
  transactionID: string;
  price: Price;
  item: Item[];


  constructor(price: Price, item: Item[]) {
    this.transactionID = UuidGenerator.UUID();
    this.price = price;
    this.item = item;
  }

  public getTransactionID(): string {
    return this.transactionID;
  }

  public getPrice(): Price {
    return this.price;
  }

  public getItem(): Item[] {
    return this.item;
  }
}
